export const classes = {
  menu: 'mt-2',
  icon: 'mr-3',
};
